// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20uQF","col":"styles_col__tf5Ai"};